import instance from '../../Config/axios';
import { setAlert } from './AlertAction';
const {
	ADD_ORDERS_REQUEST,
	ADD_ORDERS_SUCCESS,
	ADD_ORDERS_FAIL,
	GET_ORDERS_REQUEST,
	GET_ORDERS_FAIL,
	GET_ORDERS_SUCCESS,
	UPDATE_ORDERS_STATUS_REQUEST,
	UPDATE_ORDERS_STATUS_SUCCESS,
	UPDATE_ORDERS_STATUS_FAIL,
	UPDATE_ORDERS_ITEM_STATUS_FAIL,
	UPDATE_ORDERS_ITEM_STATUS_REQUEST,
	UPDATE_ORDERS_ITEM_STATUS_SUCCESS,
} = require('../constants/orderConstant');

const CreateOrder = (orderPayload, sendPdfFunc) => async (dispatch) => {
	try {
		dispatch({ type: ADD_ORDERS_REQUEST, payload: orderPayload });
		// create product
		console.log(orderPayload, 'form Action');

		const orderCreate = await instance.post('/orders/create-order', orderPayload);
		console.log(orderCreate, 'response');
		await sendPdfFunc(orderCreate.data.data.orderCreated._id);
		const orderEmail = await instance.post('/orders/send-order-email/' + orderCreate.data.data.orderCreated._id + '/' + orderPayload.lang);

		if (!orderPayload.isDrafted) {
			setAlert('Thank you!!!', 'Your order has been confirmed!', 'success');
		}

		dispatch({
			type: ADD_ORDERS_SUCCESS,
			payload: orderCreate.data,
			success: true,
		});
		// window.location.reload();
	} catch (error) {
		console.log(error, 'error');
		setAlert('Oops!', 'Something wrong, Please try later!', 'error');

		dispatch({ type: ADD_ORDERS_FAIL, payload: error.response });
	}
};

let ordersRequestId = 0;

const GetOrderAction = (page = 1, perPage = 100, name = '', sortBy = 'createdAt', sortOrder = 'desc') => async (dispatch) => {
	const requestId = ++ordersRequestId;
	const query = { page, perPage, name: name.trim(), sortBy, sortOrder };
	dispatch({ type: GET_ORDERS_REQUEST, requestId, query });
	try {
		const params = { page, perPage, sortBy, sortOrder };
		if (query.name) params.name = query.name;
		const response = await instance.get('/orders', { params });
		dispatch({ type: GET_ORDERS_SUCCESS, requestId, payload: response.data.data });
	} catch (error) {
		dispatch({
			type: GET_ORDERS_FAIL,
			requestId,
			payload: error.response?.data?.message || 'Unable to load orders. Please try again.',
		});
	}
};

// Read the latest query after the mutation, including navigation while it was pending.
const refreshOrders = (dispatch, getState) => {
	const { page, perPage, name, sortBy, sortOrder } = getState().getOrders.query;
	return dispatch(GetOrderAction(page, perPage, name, sortBy, sortOrder));
};

const UpdateOrderStatus =
	({ orderId, status }) =>
	async (dispatch, getState) => {
		try {
			dispatch({ type: UPDATE_ORDERS_STATUS_REQUEST });
			console.log(orderId, status, 'order to chage');
			const data = await instance.post(`/api/update-admin-order-status`, {
				orderId,
				status,
			});
			console.log(data, 'data from back');
			setAlert('Good job!', 'Agency Status Changed Successfully!', 'success');
			dispatch({
				type: UPDATE_ORDERS_STATUS_SUCCESS,
				payload: data.data,
				success: true,
			});
			await refreshOrders(dispatch, getState);
		} catch (error) {
			setAlert('Oops!', 'Something wrong, Please try later!', 'error');

			dispatch({ type: UPDATE_ORDERS_STATUS_FAIL, payload: error.response });
		}
	};

const UpdateOrderItemStatus =
	({ orderId, statusToChange, status }) =>
	async (dispatch, getState) => {
		try {
			dispatch({ type: UPDATE_ORDERS_ITEM_STATUS_REQUEST });
			console.log(orderId, status, 'order to chage');
			let data;
			if (statusToChange === 'isBooked') {
				data = await instance.put(`/orders/update-order-booked-status/${orderId}`, {
					bookedStatus: status,
				});
			} else {
				data = await instance.put(`/orders/update-order-confirmed-status/${orderId}`, {
					confirmedStatus: status,
				});
			}
			console.log(data, 'data from back');
			setAlert('Good job!', 'Order Status Changed Successfully!', 'success');

			dispatch({
				type: UPDATE_ORDERS_ITEM_STATUS_SUCCESS,
				payload: data.data,
				success: true,
			});
			await refreshOrders(dispatch, getState);
		} catch (error) {
			setAlert('Oops!', 'Something wrong, Please try later!', 'error');

			dispatch({
				type: UPDATE_ORDERS_ITEM_STATUS_FAIL,
				payload: error.response,
			});
		}
	};

export { CreateOrder, GetOrderAction, UpdateOrderStatus, UpdateOrderItemStatus };
